
// Deployment trigger: 2026-04-24
interface SendEmailParams {
  toEmail: string;
  toName: string;
  subject: string;
  prizeName: string;
  campaignName: string;
  isRaffle?: boolean;
  ticketNumber?: string;
  fromName?: string;
  campaignCode?: string;
  customHtmlContent?: string;
}

/**
 * Proxy function that calls our Cloudflare Backend (Functions).
 * The API key is stored securely on the server and never exposed to the client.
 */
export const sendBrevoEmail = async (params: SendEmailParams) => {
  try {
    const response = await fetch('/api/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(params)
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || "Failed to send email through backend proxy.");
    }

    return await response.json();
  } catch (error) {
    console.error("Backend Email Proxy Error:", error);
    // Silent fail in UI but logged for devs
  }
};
